// `waiting` (por enviar) and `sent` (enviado) are the default status selection
// for the orders dashboard. Shared between the filters reducer (initial state
// and REMOVE_FILTERS reset) and the dashboard chips so the "hide default status
// chips" behavior stays aligned.
export const DEFAULT_STATUSES = ['waiting', 'sent'];
